import { FC } from 'react'
import { Icon } from '@iconify/react'

import s from './AppliedFilterPill.module.css'

type Props = {
  label: string
  onClear: () => void
}

export const AppliedFilterPill: FC<Props> = ({ label, onClear }) => {
  return (
    <div className={s.appliedFilter}>
      {label}
      <button className={s.close} onClick={onClear}>
        <Icon icon="lucide:x" width={16} />
      </button>
    </div>
  )
}
